import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Targetable } from '@feathr/blackbox';
import { TargetableClass } from '@feathr/blackbox';
import { Button, EmptyState, Icon, Table } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import geoFiltersColumns from './geoFiltersColumns';

interface IGeoFiltersTableProps {
  onCreateSet: () => void;
}

function GeoFiltersTable({ onCreateSet }: Readonly<IGeoFiltersTableProps>): JSX.Element {
  const { t } = useTranslation();
  const { Targetables } = useStore();

  // TODO: Remove after integrating with backend
  // Toggle this boolean to see the empty state vs. the table with "data"
  const seeEmptyState = true;

  // TODO: When integrating, pass `geoSetTargetables` to the Table component as `items` to avoid loading the full collection.
  const geoSetTargetables = Targetables.list({
    filters: { is_archived__ne: true, _cls: TargetableClass.geo_set },
  });

  if (seeEmptyState && geoSetTargetables.isLoaded && geoSetTargetables.models.length === 0) {
    return (
      <EmptyState
        description={t('Get started by creating a new set.')}
        height={'full'}
        label={t('No geofilters')}
        theme={'white'}
        width={'full'}
      >
        <Button onClick={onCreateSet} prefix={<Icon icon={faPlus} />}>
          {t('Create set')}
        </Button>
      </EmptyState>
    );
  }

  return (
    <Table<Targetable>
      collection={Targetables}
      columns={geoFiltersColumns(t)}
      isLoading={geoSetTargetables.isPending}
    />
  );
}

export default observer(GeoFiltersTable);
